var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container-scroller"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"container-fluid page-body-wrapper"},[_c('app-sidebar'),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_vm._v(" "),_c('app-footer')],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ee909d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/BaseContainer.vue
// module id = null
// module chunks = 